import { render, staticRenderFns } from "./DriblabSVGText.vue?vue&type=template&id=3dfa1a28"
import script from "./DriblabSVGText.vue?vue&type=script&lang=js"
export * from "./DriblabSVGText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports